import { IconChevronRight16, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { PromoIcon } from 'shared/containers/NewbuildingPromosSection/parts/PromoIcon';
import { IPromoInfo } from 'shared/types/newbuildingPromos';

import * as styles from './PurchaseTermsPromo.css';

interface IPurchaseTermsPromoProps {
  title: string;
  onClick(): void;
  promo: IPromoInfo;
}

export const PurchaseTermsPromo: React.FC<IPurchaseTermsPromoProps> = ({ title, onClick, promo }) => {
  return (
    <div className={styles['promo']} onClick={onClick} data-testid="PurchaseTermsPromo">
      <div className={styles['inner']}>
        <div className={styles['promo-icon']}>
          <PromoIcon promo={promo} />
        </div>
        <div className={styles['title']}>
          <UIText1>{title}</UIText1>
          <UIText2 color="text-secondary-default">Акция от застройщика</UIText2>
        </div>
      </div>
      <div className={styles['chevron']}>
        <IconChevronRight16 />
      </div>
    </div>
  );
};
